"use client";
import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import styles from "./NotificationBanner.module.css";

interface NotificationBannerProps {
  type: "processing" | "success" | "error";
  title: string;
  message: string;
  onClose: () => void;
  visible: boolean;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  type,
  title,
  message,
  onClose,
  visible,
}) => {
  if (!visible) return null;

  const getNotificationStyle = () => {
    switch (type) {
      case "processing":
        return {
          backgroundColor: "#fff7e6",
          borderColor: "#ffd591",
          color: "#000000",
        };
      case "success":
        return {
          backgroundColor: "#e6f7ff",
          borderColor: "#91d5ff",
          color: "#1890ff",
        };
      case "error":
        return {
          backgroundColor: "#fff2f0",
          borderColor: "#ffccc7",
          color: "#ff4d4f",
        };
      default:
        return {
          backgroundColor: "#f6f6f6",
          borderColor: "#d9d9d9",
          color: "#595959",
        };
    }
  };

  const getIcon = () => {
    switch (type) {
      case "processing":
        return "⏳";
      case "success":
        return "✅";
      case "error":
        return "❌";
      default:
        return "ℹ️";
    }
  };

  const notificationStyle = getNotificationStyle();

  return (
    <div
      className={styles.notificationBanner}
      style={{
        backgroundColor: notificationStyle.backgroundColor,
        borderColor: notificationStyle.borderColor,
        color: notificationStyle.color,
      }}
    >
      <div className={styles.notificationContent}>
        <div className={styles.notificationText}>
          <div className={styles.notificationTitle}>{title}</div>
          <div className={styles.notificationMessage}>{message}</div>
        </div>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close notification"
        >
          <CloseOutlined />
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner;
